<script setup lang="ts">
import type { BreadcrumbProps } from '#seo-utils/app/composables/useBreadcrumbItems'
import { RedirectEntryType } from '~~/shared/redirect-service-types'

definePageMeta({
  layout: false,
  colorMode: 'light',
  theme: 'blurple',
  name: 'article',
})

const route = useRoute<'article'>()

const { data: article, suspense } = useArticle(() => route.params.slug)

await suspense()

if (!article.value) {
  const redirect = await redirectLookup(route.params.slug, RedirectEntryType.ARTICLE);
  if (redirect) {
    navigateTo({
      name: 'article',
      params: {
        slug: redirect.target,
      }
    });
  } else {
    throw createError({
      statusCode: 404,
      statusMessage: 'Artikkelen finnes ikke',
      fatal: true,
      data: {
        navigationContext: 'marketing' satisfies NavigationContext,
      },
    })
  }
}

const { $htmlToText } = useNuxtApp()

const title = computed(() => $htmlToText(article.value?.components?.title))

const breadcrumbs: BreadcrumbProps['overrides'] = computed(() => {
  return [
    undefined,
    undefined,
    title.value
      ? {
          label: title.value,
          to: route.path,
        }
      : undefined,
  ]
})

useHead({
  title,
  bodyAttrs: {
    class: 'bg-blurple-200',
  },
})
</script>

<template>
  <NuxtLayout name="nettbutikk" :overrides="breadcrumbs">
    <NettbutikkArticle v-if="article" :article="article" />
  </NuxtLayout>
</template>
